import type { BreadcrumbProps } from 'antd';
import { useCallback } from 'react';
import { useLocation } from 'react-router';

type Breadcrumbs = {
  title: string;
  href?: string;
}[];

/**
 * @param baseIndex - パスの基準となるindex
 * ex) /tenant-manager/organization/123/edit の場合、['', tenant-manager, organization, 123, edit] となるためデフォルトが2になる。
 */
export const useCreateBreadcrumbs = ({
  baseIndex = 2,
}: { baseIndex?: 2 | 3 }): {
  createBreadcrumb: (breadcrumbTitles: Breadcrumbs) => BreadcrumbProps['items'];
} => {
  const location = useLocation();

  /**
   * indexが若い方が上位のパスになる。
   */
  const createBreadcrumb = useCallback(
    (breadcrumbTitles: Breadcrumbs) => {
      return breadcrumbTitles.map(({ title, href }, i, arr) => {
        const index = i + 1;
        const arrLength = arr.length;
        const isLast = index === arrLength;
        const paths = location.pathname.split('/');

        return {
          title,
          href:
            href ??
            (isLast ? undefined : paths.slice(0, baseIndex + i).join('/')),
        };
      });
    },
    [location.pathname, baseIndex],
  );

  return { createBreadcrumb };
};
